// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2mcuG";
var _3 = "wrapper_gray-27GLV";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_gray" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_gray": _3 }
